// extracted by mini-css-extract-plugin
export default {"Checkbox":"CheckBox_Checkbox__Ue3jF","Circle":"CheckBox_Circle__W0kLX","CheckBoxText":"CheckBox_CheckBoxText__28Z20"};